import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  finalize,
  Observable,
  of,
  throwError,
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { SearchRequest, SearchResponse, Url } from '../models/notification-search';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private searchIsLoading = new BehaviorSubject<boolean>(false);
  isLoading$: Observable<boolean> = this.searchIsLoading.asObservable();

  constructor(private http: HttpClient) {}

  /** GET /v1/Notification/self/count — unread count for the current user/role (plain number). */
  searchCount(): Observable<number> {
    return this.http
      .get<number>(`${environment.apiUrl}/v1/Notification/self/count`)
      .pipe(catchError(() => of(0)));
  }

  searchAsync<T>(
    payload: SearchRequest,
    url: Url
  ): Observable<SearchResponse<T>> {
    this.searchIsLoading.next(true);

    return this.http
      .post<SearchResponse<T>>(
        `${environment.apiUrl}/v1/${url}/search`,
        payload
      )
      .pipe(
        catchError((error) => {
          console.error('Search Error:', error);
          return of(null);
        }),
        finalize(() => {
          this.searchIsLoading.next(false);
        })
      );
  }

  markSingleRead(id: string): Observable<any> {
    this.searchIsLoading.next(true);
    return this.http.post(`${environment.apiUrl}/v1/Notification/read`, {
      ids: [id]
    }).pipe(
      catchError((error) => {
        console.error('error:', error);
        return of(null);
      }),
      finalize(() => {
        this.searchIsLoading.next(false);
      })
    );
  }

  deleteNotificationAsync(id: string): Observable<any> {
    if (!id) {
      return of(null);
    }

    this.searchIsLoading.next(true);

    return this.http.delete(
      `${environment.apiUrl}/v1/Notification`,
      {
        body: { ids: [id] },
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    ).pipe(
      catchError(error => {
        console.error('Delete failed:', error);
        return throwError(() => error);
      }),
      finalize(() => this.searchIsLoading.next(false))
    );
  }

  markallRead(SearchRequest: SearchRequest): Observable<any> {
    this.searchIsLoading.next(true);
    return this.http.post(`${environment.apiUrl}/v1/Notification/read`, SearchRequest).pipe(
      catchError((error) => {
        console.error("error:", error);
        return of(null);
      }),
      finalize(() => {
        this.searchIsLoading.next(false);
      })
    )

  }
}
